var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BasicTop"},[_c('div',{staticClass:"TitleName"},[_c('div',[_vm._v(_vm._s(_vm.Name))])]),_vm._t("Body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }